import React from 'react';
import { AccordionGroup } from '@forwardfinancing/component-library';
import faqInfo from '../../constants/faq.js';
import { trackPageView } from '@forwardfinancing/analytics-frontend-library/index';

export class FaqPage extends React.Component {
  constructor(props) {
    super(props);
  }

  /**
   * Using the Feature Flag here is not my favorite, but because of the way
   * that the AccordionGroup component is structured, the page title
   * would be included inside the border on the accordion group.
   *
   * This is the quick and dirty fix that solves that problem
   */

  componentDidMount() {
    trackPageView({page: 'Faq'});
  }

  render() {
    return (
      <div className="faq-page page">
        <div className="faq-page__content centered-at-tab centered-at-phone">
          <h1 className="title">Frequently Asked Questions</h1>
          <AccordionGroup
            items={faqInfo.questions}
            prefix="Q."
          />
        </div>
      </div>
    );
  }
}

export default FaqPage;
